<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { X } from 'lucide-vue-next'
import { useSelectedArea, clearSelectedArea } from '@/composables/useAreaSelection'

const route = useRoute()
const selected = useSelectedArea(computed(() => route.params.project_id))
</script>

<template>
  <div v-if="selected" class="px-3 pt-2">
    <span class="inline-flex max-w-full items-center gap-1 rounded-full bg-muted px-2 py-0.5 text-xs font-medium">
      <span class="truncate">{{ selected.name || 'Selected area' }}</span>
      <button
        class="shrink-0 rounded-full text-muted-foreground transition-colors hover:text-foreground"
        title="Show all areas"
        @click="clearSelectedArea"
      >
        <X class="size-3" />
      </button>
    </span>
  </div>
</template>
